// Evidently this component does nothing more than add 48px (or other) bottom margin :/ I feel like this is a pretty heavy-handed approach! Maybe I should ditch this as I rethink how the content itself should be rendered.
import * as React from 'react';
import { styled } from '@linaria/react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  spacing?: number;
  children: React.ReactNode;
}

const Chunk = ({
  spacing = 48,
  children,
  style = {},
  ...delegated
}: Props) => {
  return (
    <Wrapper
      style={{ marginBottom: spacing, ...style }}
      {...delegated}
    >
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export default Chunk;
